export function getPrototypeShareId(prototypeUrl) {
    return new URL(prototypeUrl).pathname.split('/')[2];
}
